<ms-split-header #splitHeaderComponent [enableScroll]="isInSheetView">
    <ng-container slot="header">
        @if (showMarketHelp) {
            <ms-market-help [optionGroup]="optionGroup" [eventHelpText]="eventHelpText" />
        }
        @if (isTeamGroupingEnabled) {
            <ms-team-grouping-tab-bar [event]="event" [optionGroup]="optionGroup" (teamGroupingChange)="onTeamGroupingChange($event)" />
        }
    </ng-container>
    <ng-container slot="content">
        <div class="option-group-container player-props-container triple" [style.--option-group-rows]="visibleOptionGroups()">
            <div class="option-group-header">
                <span></span> <span>{{ overHeader }}</span> <span>{{ underHeader }}</span>
            </div>
            <div class="option-group-row flex-column" *rxFor="let optionLine of optionLines$; trackBy: trackOptionLine; strategy: 'immediate'">
                @let optionGroupId = (optionLine.overOption?.optionGroupId ?? optionLine.underOption?.optionGroupId)?.toString() ?? '';
                <div class="d-flex">
                    <div class="attribute-key">
                        @if (isShowHeadshotImage) {
                            <ms-participant-image
                                class="participant-logo"
                                [participantImage]="optionLine.underOption?.image ?? optionLine.overOption?.image"
                                [showLogoColor]="true"
                                [participantType]="participantType.Player"
                                [sportId]="event.sport.id" />
                        }
                        <div class="player-props-player-name">
                            {{ optionLine.playerName }}
                            @if (showPlayerStats && event.playerStats && optionGroup.detailedGrouping.playerStatsProps) {
                                <ms-player-stats
                                    [playerStats]="event.playerStats"
                                    [sportId]="event.sport.id"
                                    [playerStatsProps]="optionGroup.detailedGrouping.playerStatsProps"
                                    [playerIds]="getPlayers(optionLine)"
                                    [source]="optionGroup.source" />
                            } @else if (
                                optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled() &&
                                optionGroupPlayerStatisticsService.isPlayer(event, optionLine.playerName)
                            ) {
                                <ms-player-stats
                                    [statistics]="optionGroupPlayerStatisticsService.playerStatistics()"
                                    [marketId]="(optionLine.overOption?.optionGroupId ?? optionLine.underOption?.optionGroupId)?.toString()"
                                    [seasonStatisticsMessage]="seasonStatisticsMessage().avg"
                                    [isSeasonStatisticsEnabled]="optionGroupPlayerStatisticsService.isSeasonStatisticsEnabled()"
                                    [seasonStatisticsType]="SeasonStatisticsType.Average"
                                    [optionId]="(optionLine.overOption?.id ?? optionLine.underOption?.id)?.toString()"
                                    [marketType]="OptionGroupType.PlayerProps" />
                            }
                        </div>
                        @if (
                            optionGroupPlayerStatisticsService.isPlayerStatisticsEnabled() &&
                            optionGroupPlayerStatisticsService.isPlayer(event, optionLine.playerName)
                        ) {
                            <div
                                class="player-statistics-icon"
                                [class.active]="isPlayerStatisticsOpen(optionLine)"
                                (click)="togglePlayerStatistics(optionLine)">
                                <vn-icon size="12" [name]="isPlayerStatisticsOpen(optionLine) ? 'sports-stats-active' : 'sports-stats'" />
                            </div>
                        }
                    </div>
                    @if (optionLine.overOption) {
                        <ms-option
                            [tracking]="{
                                source: tracking,
                                moduleType: trackingModuleType,
                                controllerTabName: controllerTabName,
                                playersName: optionLine.playerName,
                            }"
                            [option]="optionLine.overOption"
                            [optionGroup]="optionGroup"
                            [event]="event"
                            [showPromoBadge]="!!crmPromoIdsMap.options[optionLine.overOption.id]"
                            [sourceOfPick]="sourcesOfPick"
                            [betDetails]="betDetails" />
                    } @else {
                        <ng-container *ngTemplateOutlet="emptyOption" />
                    }
                    @if (optionLine.underOption) {
                        <ms-option
                            [tracking]="getTracking(optionLine)"
                            [option]="optionLine.underOption"
                            [optionGroup]="optionGroup"
                            [event]="event"
                            [showPromoBadge]="!!crmPromoIdsMap.options[optionLine.underOption.id]"
                            [sourceOfPick]="sourcesOfPick"
                            [betDetails]="betDetails" />
                    } @else {
                        <ng-container *ngTemplateOutlet="emptyOption" />
                    }
                </div>
                @if (isPlayerStatisticsOpen(optionLine)) {
                    <ms-player-statistics
                        [statistics]="optionGroupPlayerStatisticsService.playerStatistics()"
                        [marketFilter]="optionGroup.originalId"
                        [tracking]="tracking"
                        [optionGroupName]="optionGroup.name"
                        [messages]="playerStatisticsMessages()"
                        [isSheetViewOpen]="optionGroupPlayerStatisticsService.isSheetViewOpen()"
                        [event]="event"
                        [marketId]="optionGroupId"
                        [marketType]="OptionGroupType.PlayerProps"
                        [playerName]="optionLine.playerName"
                        [iFrameHeight]="optionGroupPlayerStatisticsService.iFrameHeight()"
                        [optionId]="(optionLine.overOption?.id ?? optionLine.underOption?.id)?.toString()" />
                }
            </div>
        </div>
    </ng-container>
</ms-split-header>
@if (!isInSheetView) {
    <ms-option-panel-bottom-action [data]="showMoreData" (showMore)="onShowMore($event)" (showAllRequested)="showAllRequested.next()" />
}

<ng-template #emptyOption>
    <ms-option-pick-placeholder class="option" />
</ng-template>
